// primevue's auto import resolver doesn't seem to work for forms, we need to explicitly import it here
import "@primevue/forms";
import * as Sentry from "@sentry/vue";
import { createPinia } from "pinia";
import { cs } from "primelocale/js/cs.js";
import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import DialogService from "primevue/dialogservice";
import Ripple from "primevue/ripple";
import StyleClass from "primevue/styleclass";
import ToastService from "primevue/toastservice";
import Tooltip from "primevue/tooltip";
import { createApp, markRaw } from "vue";

import App from "./App.vue";
import "./assets/styles.scss";
import "./assets/tailwind.css";
import { getPreset } from "./layout/composables/theme";
import { i18n } from "./mixins/localization";
import router from "./router";

// unconditionally refresh after 12 hours
setTimeout(() => window.location.reload(), 12 * 60 * 60 * 1_000);

const app = createApp(App);
const pinia = createPinia();

pinia.use(({ store }) => {
    store.$router = markRaw(router);
});

if (import.meta.env.VITE_ENV === "production") {
    pinia.use(Sentry.createSentryPiniaPlugin());
    Sentry.init({
        app,
        release: `mpt-front@${__APP_VERSION__}`,
        dsn: import.meta.env.VITE_SENTRY_DSN,

        // Adds request headers and IP for users, for more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#sendDefaultPii
        sendDefaultPii: true,
        integrations: [Sentry.consoleLoggingIntegration()],
        enableLogs: true,
    });
}

app.use(pinia);
app.use(router);
app.use(PrimeVue, {
    locale: cs,
    ripple: true,
    theme: {
        preset: getPreset(),
        options: {
            darkModeSelector: ".app-dark",

            // ensures tailwind overrides component styles (https://primevue.org/tailwind/#override)
            cssLayer: {
                name: "primevue",
                order: "theme, base, primevue",
            },
        },
    },
});
app.use(ToastService);
app.use(DialogService);
app.use(ConfirmationService);
app.use(i18n);
app.directive("tooltip", Tooltip);
app.directive("ripple", Ripple);
app.directive("styleclass", StyleClass);

app.mount("#app");
